import { RadioInputLabel } from '@/components/common/RadioInput';
import { RadioInputGroupProps } from '@/components/common/RadioInputGroup';
import { Paragraph } from '@/components/common/Typography';
import IdvIntro from '@/components/idv/IdvIntro';
import { useTrackPageViewed } from '@/services/analytics/useTracking';
import { CONFLICT_OF_INTEREST_OPTIONS } from '@common/inputs';
import { isNullish } from '@common/util/types';
import { IdvForm, IdvFormType } from '../IdvForm';

type T = IdvFormType<{
    hasConflictOfInterest?: 'yes' | 'no';
}>;

const options: RadioInputGroupProps['options'] =
    CONFLICT_OF_INTEREST_OPTIONS.map(({ label, description, value }) => ({
        label: (
            <RadioInputLabel key={value} label={label}>
                <Paragraph size="sm" color="gray">
                    {description}
                </Paragraph>
            </RadioInputLabel>
        ),
        value,
    }));

export const ConflictOfInterestView = () => {
    useTrackPageViewed('IDV > ConflictOfInterestView');

    return (
        <>
            <IdvIntro
                title="Do any of these apply to you?"
                desc="We use this to understand if you have any investing limitations or restrictions."
            />
            <IdvForm<T>
                initValues={(userProfile) => ({
                    hasConflictOfInterest: !isNullish(
                        userProfile?.onboardingData?.hasConflictOfInterest
                    )
                        ? userProfile?.onboardingData?.hasConflictOfInterest
                            ? 'yes'
                            : 'no'
                        : undefined,
                })}
                toMutationInput={({ hasConflictOfInterest }) => ({
                    onboardingData: {
                        hasConflictOfInterest:
                            hasConflictOfInterest?.includes('yes'),
                    },
                })}
                backNextNavProps={{
                    onClickEventParams: {
                        location: 'IDV > ConflictOfInterestView',
                    },
                }}
            >
                <IdvForm.Input<T>
                    name="hasConflictOfInterest"
                    label=""
                    type="radio"
                    options={options}
                    radioProps={{ mb: 1 }}
                    validations={[
                        {
                            validate: (value) => value === 'no',
                            error: 'We’re sorry - at this time, we cannot currently open investments accounts where there are conflicts of interest. You may continue using the rest of the product and we’ll contact you if this changes in the future.',
                        },
                    ]}
                    isRequired
                    autoFocus
                />
            </IdvForm>
        </>
    );
};
